export default __webpack_public_path__ + "static/media/V2.c247c9f0.mp4";